import { render, staticRenderFns } from "./Prospetime.vue?vue&type=template&id=a04fd8ee&scoped=true&"
import script from "./Prospetime.vue?vue&type=script&lang=js&"
export * from "./Prospetime.vue?vue&type=script&lang=js&"
import style0 from "./Prospetime.vue?vue&type=style&index=0&id=a04fd8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04fd8ee",
  null
  
)

export default component.exports